import React from "react";
import LineageTransformationViewer from "./LineageTransformation/LineageTransformationViewer";
import heartLoading from "../../../assests/heartLoading.gif";
import useLineageTransformationData from "./LineageTransformation/useLineageTransformationData";

const LineageTransformationContent = ({ assetName }) => {
  const {
    handleSelectMermaid,
    loading,
    mermaidTypes,
    selectedMermaid,
  } = useLineageTransformationData({ assetName });

  return (
    <LineageTransformationViewer
      loading={loading}
      selectedMermaid={selectedMermaid}
      mermaidTypes={mermaidTypes}
      onSelectMermaid={handleSelectMermaid}
      assetName={assetName}
      loadingImage={heartLoading}
      loadingMessage="Loading lineage transformation..."
      emptyMessage="No Lineage Transformation data available for this asset."
      emptyTextClassName="text-gray-700 text-[12px]"
      rootClassName="h-[calc(90vh-300px)] flex flex-col min-h-0 pt-0"
    />
  );
};

export default LineageTransformationContent;
